import TabellaLezioni from "./storico/storico_lezioni/tabellaLezioni.jsx"
import TabsPacchetti from "./storico/storico_lezioni/tabs_pacchetto.jsx"
import NoleggiStorico from "./storico/storico_noleggi/noleggi.jsx"
import StorageStorico from "./storico/storage/storage.jsx"
import EscursioniStorico from "./storico/storico_escursioni/storico_esc.jsx"
import SpeseStoricoVilla from "./storico_villa/storico_spese/storico_spese.jsx"
import Paginaprenotazioni from "./storico_villa/storico_prenotazioni/storico_prenotazioni.jsx"
import { useEffect, useState, useRef } from "react";
import {getIndiceStoricoVilla, getLingua, setIndiceStoricoVilla} from "../auth";
import "../stili/tabs.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-free/css/all.min.css"
import {dizionarioTraduzioni} from "../funzioni/traduzioni";
/* global $ */
function StoricoVilla() {
    const lingua=getLingua()
    const [selectedIndex,setSelectedIndex]=useState(0)
    const [selectedIndex2,setSelectedIndex2]=useState(0)
  useEffect(() => {
    const tabsIconAndText = [
      { id: 0, text: dizionarioTraduzioni(lingua,'Prenotazioni'), icon: "fa-solid fa-book-open" },
      { id: 1, text: dizionarioTraduzioni(lingua,'Spese'), icon: 'fa-solid fa-credit-card' },
    ];

    const tabs =$('#withIconAndText').dxTabs({
      width: '100%',
      rtlEnabled: false,
      scrollByContent: true,
      dataSource: tabsIconAndText,
      orientation: "horizontal",
      stylingMode: "secondary",
      iconPosition: "top",
      onSelectionChanged: function (e) {
      setSelectedIndex( e.component.option("selectedIndex"));
      let passo =false
      e.component.option("selectedIndex")>=0?setIndiceStoricoVilla(e.component.option("selectedIndex")):passo=true
    },
      itemTemplate: function (itemData) {
          return `<div style="display: flex; flex-direction: column; align-items: center;">
                    <i class="${itemData.icon}" style="font-size: 20px;"></i>
                    <div>${itemData.text}</div>
                  </div>`;
        },
    }).dxTabs('instance');
    tabs.option("selectedIndex", getIndiceStoricoVilla()>=0?getIndiceStoricoVilla():0)
  }, []);
  return (
  <div>
  <div id="withIconAndText" ></div>
  {selectedIndex===1 && <SpeseStoricoVilla/>}
  {selectedIndex===0 && <Paginaprenotazioni/>}
  <div id="loadingOverlay">
      <div class="spinner">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
  </div>
  </div>)
}
export default StoricoVilla;